import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from '@pages/LandingPage'
import LoginPage from '@pages/LoginPage'
import RegisterPage from '@pages/RegisterPage_new'
import HomePage from '@pages/HomePage'
import QuotationDetails from '@pages/QuotationDetails'
import SuppliersPage from '@pages/SuppliersPage'
import SupplierQuotation from '@pages/SupplierQuotation'
import SupplierQuotationByParams from '@pages/SupplierQuotationByParams'
import ToastContainer from '@components/ui/ToastContainer'
import { ToastProvider } from './contexts/ToastContext'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/app" element={<HomePage />} />
                <Route path="/quotation/:id" element={<QuotationDetails />} />
                <Route path="/suppliers" element={<SuppliersPage />} />
                <Route path="/supplier/:linkToken" element={<SupplierQuotation />} />
                <Route path="/cotacao/:id/fornecedor/:supplierId" element={<SupplierQuotationByParams />} />
              </Routes>
              <ToastContainer />
            </div>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App